function removeAllButton(event) {
    event.preventDefault();

    let relocateUrl = event.currentTarget.dataset.dropCart,
        actionUrl = event.currentTarget.href;

    $.get(actionUrl, () => {
        window.location.href = relocateUrl;
    });
}


function addToCartNew() {
    $('body').on('click', '.add-to-cart', function (e) {
        e.preventDefault();

        const product_id = $(this).data('product-id');
        const ajaxData = {
            action: 'ajax_add_to_cart',
            product_id: product_id,
            quantity: 1,
        };
        $.post(settings.ajax_url, ajaxData)
            .done((response) => {
                response = JSON.parse(response);
                console.log(response);

                if($(this).hasClass('configurator__add-co-cart')) {
                    $(this).closest('.configurator__bottom-input').addClass('configurator__bottom-input--added');
                    $(this).replaceWith('<button class="btn btn--primary">Dodano</button>');
                }
            });
    });
}

function handleOptionActive(event) {
    $(event.currentTarget).closest('li').siblings().removeClass('active');
    $(event.currentTarget).closest('li').addClass('active');
    $(event.currentTarget).parent().addClass('active');
}

function init() {
    const cartPage = document.querySelector('.cart-page'),
        checkoutPage = document.querySelector('.checkout-page__summary'),
        productPage = document.querySelector('.single-product');

    if (cartPage || checkoutPage) {
        if (cartPage) {
            $(cartPage).on('click', '[data-drop-cart]', (event) => removeAllButton(event));
        }

        // Coupon toggle functionality
        const couponToggle = document.querySelector('.coupon-toggle');
        const couponForm = document.querySelector('.coupon-form');

        if (couponToggle && couponForm) {
            couponToggle.addEventListener('click', function(e) {
                // Nie blokuj jeśli kliknięto na przycisk submit wewnątrz
                if (e.target.closest('.coupon-button') || e.target.closest('.coupon-form')) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                const iconMinus = this.querySelector('.icon-minus');
                const iconPlus = this.querySelector('.icon-plus');

                if (couponForm.style.display === 'none' || !couponForm.style.display) {
                    couponForm.style.display = 'block';
                    if (iconPlus) iconPlus.style.display = 'none';
                    if (iconMinus) iconMinus.style.display = 'block';
                } else {
                    couponForm.style.display = 'none';
                    if (iconPlus) iconPlus.style.display = 'block';
                    if (iconMinus) iconMinus.style.display = 'none';
                }
            });
        }

        // Products list toggle functionality (checkout)
        const productsToggle = document.querySelector('.checkout-products-toggle');
        const productsList = document.querySelector('.checkout-products-list');

        if (productsToggle && productsList) {
            productsToggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const iconMinus = this.querySelector('.icon-minus');
                const iconPlus = this.querySelector('.icon-plus');

                if (productsList.style.display === 'none') {
                    productsList.style.display = 'block';
                    if (iconPlus) iconPlus.style.display = 'none';
                    if (iconMinus) iconMinus.style.display = 'block';
                } else {
                    productsList.style.display = 'none';
                    if (iconPlus) iconPlus.style.display = 'block';
                    if (iconMinus) iconMinus.style.display = 'none';
                }
            });
        }

        // AJAX coupon apply - obsługa dla obu: checkout i koszyk
        const applyCouponCheckout = document.querySelector('#apply_coupon_checkout');
        const couponInputCheckout = document.querySelector('#coupon_code_checkout');
        const applyCouponSidebar = document.querySelector('#apply_coupon_sidebar');
        const couponInputSidebar = document.querySelector('#coupon_code_sidebar');

        function showCouponMessage(input, message, isSuccess) {
            // Usuń poprzedni komunikat
            const wrapper = input.closest('.coupon-form') || input.closest('.coupon-input-wrapper').parentElement;
            const existingMsg = wrapper.querySelector('.coupon-message');
            if (existingMsg) existingMsg.remove();

            // Dodaj nowy komunikat
            const msgEl = document.createElement('div');
            msgEl.className = 'coupon-message ' + (isSuccess ? 'coupon-message--success' : 'coupon-message--error');
            msgEl.textContent = message;
            wrapper.appendChild(msgEl);

            // Usuń po 5 sekundach
            setTimeout(() => {
                if (msgEl.parentElement) msgEl.remove();
            }, 5000);
        }

        function applyCoupon(btn, input) {
            if (!btn || !input) return;

            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const couponCode = input.value.trim();

                if (!couponCode) {
                    showCouponMessage(input, 'Proszę wpisać kod kuponu.', false);
                    return;
                }

                btn.disabled = true;
                btn.classList.add('loading');

                // Dodaj spinner
                const spinner = document.createElement('span');
                spinner.className = 'coupon-spinner';
                btn.appendChild(spinner);

                $.ajax({
                    type: 'POST',
                    url: settings.ajax_url,
                    data: {
                        action: 'apply_coupon_ajax',
                        coupon_code: couponCode
                    },
                    success: function(response) {
                        if (response.success) {
                            // Pokaż komunikat sukcesu
                            showCouponMessage(input, response.data.message || 'Kupon został dodany.', true);

                            // Aktualizuj kontener kuponów
                            const couponsContainer = document.querySelector('.applied-coupons-container');
                            if (couponsContainer) {
                                couponsContainer.innerHTML = response.data.coupons_html;
                            }

                            // Aktualizuj total
                            const totalValue = document.querySelector('.payment-summary__line--total .payment-summary__value');
                            if (totalValue && response.data.total) {
                                totalValue.innerHTML = response.data.total;
                            }

                            // Wyczyść input
                            input.value = '';

                            // Podepnij eventy usuwania kuponów
                            bindRemoveCouponEvents();

                            // Jeśli jesteśmy na checkout, zaktualizuj też order review
                            const isCheckout = document.querySelector('.woocommerce-checkout');
                            if (isCheckout && typeof wc_checkout_params !== 'undefined') {
                                $(document.body).trigger('update_checkout');
                            }
                        } else {
                            // Pokaż komunikat błędu
                            showCouponMessage(input, response.data.message || 'Nie udało się dodać kuponu.', false);
                        }

                        btn.disabled = false;
                        btn.classList.remove('loading');
                        const spinnerEl = btn.querySelector('.coupon-spinner');
                        if (spinnerEl) spinnerEl.remove();
                    },
                    error: function() {
                        showCouponMessage(input, 'Wystąpił błąd. Spróbuj ponownie.', false);
                        btn.disabled = false;
                        btn.classList.remove('loading');
                        const spinnerEl = btn.querySelector('.coupon-spinner');
                        if (spinnerEl) spinnerEl.remove();
                    }
                });
            });
        }

        // Funkcja do usuwania kuponów
        function removeCoupon(couponCode, removeBtn) {
            // Dodaj spinner przy przycisku usuwania
            removeBtn.classList.add('loading');
            const originalText = removeBtn.textContent;
            removeBtn.innerHTML = '<span class="coupon-spinner"></span>';

            $.ajax({
                type: 'POST',
                url: settings.ajax_url,
                data: {
                    action: 'remove_coupon_ajax',
                    coupon_code: couponCode
                },
                success: function(response) {
                    if (response.success) {
                        // Usuń element kuponu z DOM
                        const couponElement = document.querySelector('.payment-summary__line--coupon[data-coupon="' + couponCode + '"]');
                        if (couponElement) {
                            couponElement.remove();
                        }

                        // Aktualizuj total
                        const totalValue = document.querySelector('.payment-summary__line--total .payment-summary__value');
                        if (totalValue && response.data.total) {
                            totalValue.innerHTML = response.data.total;
                        }

                        // Jeśli jesteśmy na checkout, zaktualizuj
                        const isCheckout = document.querySelector('.woocommerce-checkout');
                        if (isCheckout && typeof wc_checkout_params !== 'undefined') {
                            $(document.body).trigger('update_checkout');
                        }
                    } else {
                        alert(response.data.message || 'Nie udało się usunąć kuponu.');
                        removeBtn.classList.remove('loading');
                        removeBtn.textContent = originalText;
                    }
                },
                error: function() {
                    alert('Wystąpił błąd. Spróbuj ponownie.');
                    removeBtn.classList.remove('loading');
                    removeBtn.textContent = originalText;
                }
            });
        }

        // Podpinanie eventów usuwania kuponów
        function bindRemoveCouponEvents() {
            document.querySelectorAll('.remove-coupon').forEach(function(btn) {
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    const couponCode = this.getAttribute('data-coupon');
                    if (couponCode) {
                        removeCoupon(couponCode, this);
                    }
                });
            });
        }

        // Inicjalizacja eventów usuwania kuponów
        bindRemoveCouponEvents();

        applyCoupon(applyCouponCheckout, couponInputCheckout);
        applyCoupon(applyCouponSidebar, couponInputSidebar);

        // Re-bind events after WooCommerce AJAX updates (for checkout page)
        $(document.body).on('updated_checkout', function() {
            bindRemoveCouponEvents();

            // Re-init coupon functionality after checkout update
            const newApplyCouponCheckout = document.querySelector('#apply_coupon_checkout');
            const newCouponInputCheckout = document.querySelector('#coupon_code_checkout');

            if (newApplyCouponCheckout && newCouponInputCheckout) {
                // Remove old event listeners by cloning
                const newBtn = newApplyCouponCheckout.cloneNode(true);
                newApplyCouponCheckout.parentNode.replaceChild(newBtn, newApplyCouponCheckout);
                applyCoupon(newBtn, newCouponInputCheckout);
            }
        });

        // Handle WooCommerce update_cart event (for cart page)
        $(document.body).on('updated_cart_totals', function() {
            bindRemoveCouponEvents();

            // Re-init coupon functionality after cart update
            const newApplyCouponSidebar = document.querySelector('#apply_coupon_sidebar');
            const newCouponInputSidebar = document.querySelector('#coupon_code_sidebar');

            if (newApplyCouponSidebar && newCouponInputSidebar) {
                // Remove old event listeners by cloning
                const newBtn = newApplyCouponSidebar.cloneNode(true);
                newApplyCouponSidebar.parentNode.replaceChild(newBtn, newApplyCouponSidebar);
                applyCoupon(newBtn, newCouponInputSidebar);
            }
        });
    }

    if (checkoutPage) {
        $("#shippingMethod .js-remove").remove();

        // Delegated events - survive WooCommerce AJAX fragment replacements (update_checkout)
        $(document.body).on('click', 'ul.wc_payment_methods label', (event) => handleOptionActive(event));
        $(document.body).on('click', 'ul.woocommerce-shipping-methods label', (event) => handleOptionActive(event));

        $(document.body).on('updated_checkout', function () {
            $("#shippingMethod .js-remove").remove();
        });
    }

    if (productPage) {
        // addToCartNew();
    }


}

function updateMiniCart() {
    let ajaxAddToCartBtns = document.querySelectorAll('.ajax_add_to_cart');
    ajaxAddToCartBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            console.log(e);
            let ajaxData = {
                action: 'ajax_update_mini_cart',
            };
            $.post(settings.ajax_url, ajaxData)
                .done((response) => {
                    response = JSON.parse(response);
                    $('.header__cart .widget_shopping_cart_content').html(response);
                    updateCartAmount();
                    dropdownCart();
                });
        });
    });
}

function dropdownCart() {
    // Disabled - sliding cart handles cart click now
    // Hide old dropdowns
    let desktopDropdown = document.querySelector('.cart-content-desktop');
    if (desktopDropdown) {
        desktopDropdown.style.display = 'none';
    }
    let mobileDropdown = document.querySelector('.cart-content-mobile');
    if (mobileDropdown) {
        mobileDropdown.style.display = 'none';
    }
}
function updateCartAmount() {
    let ajaxData = {
        action: 'calculate_cart_size',
    };
    $.post(settings.ajax_url, ajaxData)
        .done((response) => {
            response = JSON.parse(response);
            $('.header__link__span').html(response.cartCount);
        });

}

export default {init, updateMiniCart, dropdownCart};